import request,{newRequest} from '@/utils/request'

// 权限列表
export const list = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/authority/querylist', params).then((res:any)=>{
    res.data.forEach((e:any)=>{
        if(!e.authorities&&e.authoritys){
            e.authorities=e.authoritys;
        }
    })
    return res;
})

// 新增权限
export const authorityAdd = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/authority/add', params)

// 修改权限
export const authorityUpdate = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/authority/update', params)

// 权限详情
export const authorityDetails = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/authority/query', params)

// 禁用权限
export const isDisable = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/authority/disable', params)

// 启用权限
export const isEnable = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/authority/enable', params)

// 删除权限
export const authorityDelete = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/authority/delete', params)

// 查询权限授权信息
export const authorityInfo = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/authority/info', params)

// 权限授权
export const authorize = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/authority/authorize', params)

// 新增组
export const groupAdd = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/authorityGroup/add', params)

// 修改组
export const groupUpdate = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authorityGroup/update', params)

// 删除组
export const groupDelete = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/authorityGroup/delete', params)
